import { json } from '@remix-run/node'
import type { MetaFunction, ActionFunctionArgs } from '@remix-run/node'
import { Container } from '~/application/components/Container/Container'
import { Content } from '~/application/components/Content/Content'
import { SignupForm } from '~/domain/auth/components/SignupForm/SignupForm'
import { authenticator } from '~/domain/auth/services/authService'
import { getMeta } from '~/application/services/metaService'

export const meta: MetaFunction = ({ location }) => {
  return getMeta({
    title: 'アカウント作成',
    url: location.pathname,
  })
}

export async function loader() {
  return json({})
}

export async function action({ request }: ActionFunctionArgs) {
  return await authenticator.authenticate('user-create', request, {
    successRedirect: '/',
    failureRedirect: '/signup',
  })
}

export default function Index() {
  return (
    <Content>
      <Container size="sm">
        <h1 className="text-xl mb-8 text-primary-600">アカウント作成</h1>
        <SignupForm />
      </Container>
    </Content>
  )
}
